import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface DeleteAgentData {
  agentUuid: string;
}

interface DeleteAgentResponse {
  data: any;
}

export function useDeleteAgent() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      deleteData: DeleteAgentData
    ): Promise<DeleteAgentResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/delete_agent`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(deleteData),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['userAgents'],
      });
    },
  });
}
